import { useTranslation } from 'react-i18next'
import './AudioPlayer.css'

export const AudioPlayerPlaceholder = () => {
    const { t } = useTranslation()
    return <div className="audio-player-placeholder">{t('noAudioRecorded')}</div>
}
